<app-custom-modal
  [title]="title"
  [showCloseButton]="false"
  [showBackButton]="true"
  [actionButtons]="actionButtons()"
  [hideActionButtons]="hideActionButtons()"
  (actionClicked)="handleAction($event)"
  (backClicked)="handleBack()"
>
  <div class="modal-content-standard">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-card>
            <ion-card-content>
              <p>
                <em>
                  This Cookie Policy was last updated on May 25, 2025 and applies to citizens and
                  legal permanent residents of the European Economic Area and Switzerland.
                </em>
              </p>
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>1. Introduction</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <p>
                Our website,
                <a href="https://dhig.net">https://dhig.net</a>
                (hereinafter: "the website") uses cookies and other related technologies (for
                convenience all technologies are referred to as "cookies"). Cookies are also placed
                by third parties we have engaged. In the document below we inform you about the use
                of cookies on our website.
              </p>
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>2. What are cookies?</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <p>
                A cookie is a small simple file that is sent along with pages of this website and
                stored by your browser on the hard drive of your computer or another device. The
                information stored therein may be returned to our servers or to the servers of the
                relevant third parties during a subsequent visit.
              </p>
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>3.What are scripts?</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <p>
                A script is a piece of program code that is used to make our website function
                properly and interactively. This code is executed on our server or on your device.
              </p>
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>4. What is a web beacon?</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              A web beacon (or a pixel tag) is a small, invisible piece of text or image on a
              website that is used to monitor traffic on a website. In order to do this, various
              data about you is stored using web beacons.
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>5. Cookies</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <br />
              <h3><strong>5.1 Technical or functional cookies</strong></h3>

              <p>
                Some cookies ensure that certain parts of the website work properly and that your
                user preferences remain known. By placing functional cookies, we make it easier for
                you to visit our website. This way, you do not need to repeatedly enter the same
                information when visiting our website and, for example, the items remain in your
                shopping cart until you have paid. We may place these cookies without your consent.
              </p>

              <br />
              <h3><strong>5.2 Statistics cookies</strong></h3>

              <p>
                We use statistics cookies to optimize the website experience for our users. With
                these statistics cookies we get insights in the usage of our website. We ask your
                permission to place statistics cookies.
              </p>

              <br />
              <h3><strong>5.3 Advertising cookies</strong></h3>

              <p>
                On this website we use advertising cookies, enabling us to gain insights into the
                campaign results. This happens based on a profile we create based on your behavior
                on https://dhig.net. With these cookies you, as website visitor, are linked to a
                unique ID but these cookies will not profile your behavior and interests to serve
                personalized ads.
              </p>

              <br />
              <h3><strong>5.4 Marketing/Tracking cookies</strong></h3>

              <p>
                Marketing/Tracking cookies are cookies or any other form of local storage, used to
                create user profiles to display advertising or to track the user on this website or
                across several websites for similar marketing purposes.
              </p>

              <p>
                Because these cookies are marked as tracking cookies, we ask your permission to
                place these.
              </p>
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>6. Enabling/disabling and deleting cookies</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <p>
                You can use your internet browser to automatically or manually delete cookies. You
                can also specify that certain cookies may not be placed. Another option is to change
                the settings of your internet browser so that you receive a message each time a
                cookie is placed. For more information about these options, please refer to the
                instructions in the Help section of your browser.
              </p>

              <p>
                Please note that our website may not work properly if all cookies are disabled. If
                you do delete the cookies in your browser, they will be placed again after your
                consent when you visit our website again.
              </p>
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>7. Your rights with respect to personal data</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <p>You have the following rights with respect to your personal data:</p>

              <ul>
                <li>
                  You have the right to know why your personal data is needed, what will happen to
                  it, and how long it will be retained for.
                </li>
                <li>
                  Right of access: You have the right to access your personal data that is known to
                  us.
                </li>
                <li>
                  Right to rectification: you have the right to supplement, correct, have deleted or
                  blocked your personal data whenever you wish.
                </li>
                <li>
                  If you give us your consent to process your data, you have the right to revoke
                  that consent and to have your personal data deleted.
                </li>
                <li>
                  Right to transfer your data: you have the right to request all your personal data
                  from the controller and transfer it in its entirety to another controller.
                </li>
                <li>
                  Right to object: you may object to the processing of your data. We comply with
                  this, unless there are justified grounds for processing.
                </li>
              </ul>

              <p>
                To exercise these rights, please contact us. Please refer to the contact details at
                the bottom of this Cookie Policy. If you have a complaint about how we handle your
                data, we would like to hear from you, but you also have the right to submit a
                complaint to the supervisory authority (the Data Protection Authority).
              </p>
            </ion-card-content>
          </ion-card>

          <ion-card>
            <ion-card-header>
              <ion-card-title>8. Contact details</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <p>
                For questions and/or comments about our Cookie Policy and this statement, please
                contact us by using the following contact details:
              </p>

              <p>
                <br />
                <span>dhig GmbH</span>
                <br />
                <span>Am Heumarkt 10/1</span>
                <br />
                <span>1030 Wien</span>
                <br />
                <span>AUSTRIA</span>
                <br />
                <span>Austria</span>
                <br />
                <span>
                  Website:
                  <a href="https://dhig.net" target="_blank">https://dhig.net</a>
                </span>
                <br />
                <span>
                  Email:
                  <a href="mailto:dpo@dhig.net">dpo&#64;dhig.net</a>
                </span>
                <br />
                <span>Phone number: +43130081810</span>
                <br />
              </p>
              <br />

              <p>
                This Cookie Policy was synchronized with
                <a href="https://cookiedatabase.org/" target="_blank">cookiedatabase.org</a>
                on August 11, 2025.
              </p>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</app-custom-modal>
